<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">

  div

    div.c-auth-page__head
      h1 {{ $t('h1') }}

    div
      p Происходит выход из личного кабинета
      p Пожалуйста, подождите...

</template>

<script>
import mFormSubmit from 'mixins/formSubmit';
import * as types from 'store/mutation-types';

export default {
  mixins: [mFormSubmit],

  mounted() {
    this.logout();
  },

  methods: {
    logout() {
      this.$http
        .get('/logout')
        .then((response) => {
          this.$store.commit(`configuration/${types.UPDATE_IS_AUTHORIZED}`, false);

          if (_.has(response, 'data.redirect_url')) {
            window.location = _.get(response, 'data.redirect_url');
          } else {
            this.$router.push({ name: 'enter-number' });
          }
        })
        .catch((error) => {
          this.$router.push({ name: 'enter-number' });
        });
    },
  },
};
</script>
